import { Injectable } from '@angular/core';
import { ICmsModelResource } from '../model/icms-model.resource';
import { ICmsGroup } from './icms-group';

declare module '@df/catalog/resource' {
    interface IResources {
        group: Resource<ICmsGroup, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ICmsGroupResource extends ICmsModelResource<ICmsGroup, number> {
    static override instance = ICmsGroup;
    readonly invalidatesUniversal = false;
    readonly invalidatesPrerender = false;
    async retrieve(path: string): Promise<ICmsGroup | undefined> {
        return (await this.findOne({ filter: { path }, verbosity: 1 })) || undefined;
    }
}
